import styled from "styled-components";
import TextareaAutosize from "react-textarea-autosize";

export const TeaserTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: ${({ isAutoGenerated, isShort }) =>
    isAutoGenerated ? (isShort ? 50 : 145) : null}px;
  padding: ${(props) => props.padding};
  border-radius: 6px;
  transition: all 0.2s;

  animation: "";
  ${(props) =>
    props.editable &&
    `
    ${props.allowEmpty ? "min-height: 30px;" : ""}
    cursor: pointer;
    user-select: none;
    &:hover {
      background-color: ${props.dark ? "#44424C" : "#f2f2f2"};
    };
  `}
`;

export const TeaserInput = styled(TextareaAutosize)`
  width: 100%;
  padding: ${(props) => props.padding};
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0.03em;
  text-align: left;
  font-family: "Source Sans Pro";
  background-color: transparent;
  animation: "";
  resize: none;
`;

export const TeaserEditorWrapper = styled.form`
  position: relative;

  ${TeaserInput} {
    background-color: ${(props) => (props.dark ? "#44424C90" : "#ffffffe8")};
  }
  .emoji-mart-anchors {
    border-radius: 5px 5px 0 0;
    background-color: white;
    position: relative;
  }
  .emoji-mart-emoji,
  .emoji-mart-preview-skins {
    cursor: pointer;
    span {
      cursor: pointer;
    }
  }
  .emoji-mart-preview-skins {
    .emoji-mart-skin-swatch {
      transition: all 0.2s;
    }
    .emoji-mart-skin-swatch:hover {
      transform: scale(1.2);
    }
  }
`;

export const EditorActions = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  transition: all 0.2s;
  ${(props) =>
    props.editingTeaser
      ? `
    margin-bottom: 0;
    opacity: 1;
    visibility: visible;
  `
      : `
    margin-bottom: -45px;
    opacity: 0;
    visibility: hidden;
  `};
`;

export const EditorUpdateActions = styled.div`
  display: flex;
`;

export const EditorInsertActions = styled.div`
  display: flex;
`;

export const CancelButtonWrapper = styled.div`
  margin-right: ${(props) => (props.small ? "3px" : "12px")};
`;

export const ErrorMessage = styled.div`
  font-family: Rubik;
  font-size: 11px;
  min-height: 13px;
  color: #ff0202;
  font-weight: 500;
  text-align: left;
`;

export const InputLimit = styled.div`
  position: absolute;
  right: 0;
  font-weight: 400 !important;
  font-size: 12px;
  line-height: 1 !important;
`;
